// Entry branching of main.ts, with every side effect injected so tests can run it.
export type StartupEnv = {
  isMobile: boolean;
  language: string;
  location: Pick<Location, "pathname" | "search" | "hash" | "replace">;
  head: { append(node: Node): void };
  createLink(): HTMLLinkElement;
  mountAdminSettings(): Promise<void>;
  listenForInstall(): Promise<void>;
  initializeTelemetry(): Promise<void>;
  loadGame(): Promise<unknown>;
  showGuide(): Promise<void>;
};

export async function startup(env: StartupEnv): Promise<void> {
  const { location } = env;
  if (location.pathname === "/admin/settings") {
    await env.mountAdminSettings();
  } else if (env.isMobile) {
    // Gate direct game and invitation links before telemetry, WebGL, or audio starts.
    const search = new URLSearchParams(location.search);
    // The server redirects /?room=... to /play, so carry it under a landing-only key.
    if (search.has("room")) {
      search.set("desktopRoom", search.get("room") ?? "");
      search.delete("room");
    }
    location.replace(
      `${env.language === "en" ? "/en/" : "/"}${search.size ? `?${search}` : ""}#desktop-link`,
    );
  } else {
    await env.listenForInstall();
    const manifest = env.createLink();
    manifest.rel = "manifest";
    manifest.href = "/manifest.webmanifest";
    env.head.append(manifest);
    await env.initializeTelemetry();
    await env.loadGame();
    if (location.hash === "#credits") await env.showGuide();
  }
}
